import React, { useState } from 'react';
import axios from 'axios';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { useToast } from '../hooks/use-toast';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminCreditPanel = () => {
  const [email, setEmail] = useState('');
  const [delta, setDelta] = useState('');
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !delta.trim()) return;

    const amount = parseInt(delta, 10);
    if (Number.isNaN(amount)) {
      toast({
        title: 'Invalid amount',
        description: 'Delta must be an integer (positive or negative).',
        variant: 'destructive',
      });
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${BACKEND_URL}/api/admin/credits/adjust`,
        { email, delta: amount },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast({
        title: 'Credits updated',
        description: `User ${response.data.email} now has ${response.data.credits} credits.`,
      });
      setEmail('');
      setDelta('');
    } catch (error) {
      console.error('Error adjusting credits:', error);
      toast({
        title: 'Adjustment failed',
        description:
          error.response?.data?.detail || 'Unable to adjust credits right now.',
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 items-start sm:items-end">
      <div className="flex-1 w-full">
        <label className="block text-xs text-gray-200 mb-1">User Email</label>
        <Input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="user@example.com"
          className="bg-black/40 border-white/20 text-sm text-white"
        />
      </div>
      <div className="w-32">
        <label className="block text-xs text-gray-200 mb-1">Delta</label>
        <Input
          type="number"
          value={delta}
          onChange={(e) => setDelta(e.target.value)}
          placeholder="1000"
          className="bg-black/40 border-white/20 text-sm text-white"
        />
      </div>
      <Button
        type="submit"
        disabled={loading}
        className="bg-yellow-500 hover:bg-yellow-600 text-black text-xs font-semibold px-4 py-2"
      >
        {loading ? 'Updating...' : 'Update Credits'}
      </Button>
    </form>
  );
};

export default AdminCreditPanel;
